import {get, post} from "./index.js";

const list_batches = async () => {
    return get(`/batch/`);
}

const add_batch = async (designation) => {
    return post(`/batch/add`, {designation});
}

const edit_batch = async (variable) => {
    const {id, ...edit} = variable;
    return post(`/batch/${id}/edit`, edit);
}

const delete_batch = async (id) => {
    return post(`/batch/${id}/delete`);
}

const add_keyframe = async (batch_id, keyframe) => {
    return post(`/batch/${batch_id}/keyframe/add`, keyframe);
}

const edit_keyframe = async (batch_id, keyframe) => {
    const {id, type: _, ...edit} = keyframe;
    return post(`/batch/${batch_id}/keyframe/${id}/edit`, edit);
}

const delete_keyframe = async (batch_id, id) => {
    return post(`/batch/${batch_id}/keyframe/${id}/delete`);
}

const run_batch = async (batch_id) => {
    return post(`/batch/${batch_id}/run`);
}

const stop_batch = async (batch_id) => {
    return post(`/batch/${batch_id}/stop`);
}

const reset_batch = async (batch_id) => {
    return post(`/batch/${batch_id}/reset`);
}

export {
    list_batches,
    add_batch,
    edit_batch,
    delete_batch,
    add_keyframe,
    edit_keyframe,
    delete_keyframe,
    run_batch,
    stop_batch,
    reset_batch
}
